import { db, storage } from "../../firebase";
import {
  collection, query, where, orderBy, limit, onSnapshot,
  getDocs, startAfter, addDoc, serverTimestamp, doc, getDoc, updateDoc, arrayUnion, arrayRemove
} from "firebase/firestore";
import { ref as sref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import {
  MSG_RESET, MSG_LIVE_STARTED, MSG_LIVE_SNAPSHOT, MSG_LIVE_ERROR,
  MSG_OLDER_REQUEST, MSG_OLDER_SUCCESS, MSG_OLDER_FAILURE, MSG_SET_HAS_MORE,
  MSG_SENDING, MSG_SENT, MSG_SEND_ERROR, MSG_UPLOAD_PROGRESS, MSG_TOGGLE_PIN, MSG_SET_PINNED_LIST
  ,MSG_PENDING_ADD, MSG_UPLOAD_DONE
} from "./MessagesTypes";
import { normEmail, threadKeyFromTwo } from "../../util/email";
import { ensureDMThread, touchThreadOnSend } from "./ThreadsAction";

const PAGE = 40;
let _unsubMsg = null, _liveKey = null;

export const fetchMessagesReset = () => { try{_unsubMsg?.()}catch{} _unsubMsg=null; _liveKey=null; return { type: MSG_RESET }; };

export const listenToMessagesLive = ({ threadId, pageSize = PAGE, onNewMessage }) => (dispatch) => {
  if (!threadId) return () => {};
  dispatch({ type: MSG_LIVE_STARTED });

  try { _unsubMsg?.(); } catch {}
  const qLive = query(
    collection(db,"messages"),
    where("threadId","==", threadId),
    orderBy("createdAt","desc"),
    limit(pageSize)
  );
  _liveKey = threadId;
  _unsubMsg = onSnapshot(qLive, (snap) => {
    const docsDesc = snap.docs.map(d => ({ id: d.id, ...d.data(), _snapRef: d }));
    if (onNewMessage && docsDesc.length) onNewMessage(docsDesc[0]);
    dispatch({ type: MSG_LIVE_SNAPSHOT, payload: { docsDesc, threadId } });
    dispatch({ type: MSG_SET_HAS_MORE, payload: docsDesc.length === pageSize });
  }, (err)=>dispatch({ type: MSG_LIVE_ERROR, payload: err.message }));
  return _unsubMsg;
};


export const watchMessage = (id) => (dispatch) => {
  return onSnapshot(doc(db,"messages", id), (snap) => {
    if (snap.exists()) {
      dispatch({
        type: MSG_TOGGLE_PIN,
        payload: { messageId: id, pinned: !!snap.data().pinned }
      });
    }
  });
};

export const loadOlderMessages = () => async (dispatch, getState) => {
  const s = getState().messages;
  const { threadId, hasMoreOlder, loadingOlder, oldestCursor } = s || {};
  if (!threadId || loadingOlder || !hasMoreOlder || !oldestCursor) return;

  
  dispatch({ type: MSG_OLDER_REQUEST });
  try {
    const qOlder = query(
      collection(db,"messages"),
      where("threadId","==", threadId),
      orderBy("createdAt","desc"),
      startAfter(oldestCursor),
      limit(PAGE)
    );
    const snap = await getDocs(qOlder);
    const batchDesc = snap.docs.map(d => ({ id: d.id, ...d.data(), _snapRef: d }));
    batchDesc.forEach(m => dispatch(watchMessage(m.id)));
    dispatch({ type: MSG_SET_HAS_MORE, payload: batchDesc.length === PAGE });
    dispatch({ type: MSG_OLDER_SUCCESS, payload: batchDesc });
  } catch (err) {
    dispatch({ type: MSG_OLDER_FAILURE, payload: err.message });
  }
};


const detectLinks = (text="") => (text.match(/https?:\/\/[^\s]+/gi) || []).slice(0, 10);


// export const sendMessage = ({ threadId, senderEmail, senderName, text, files, participantsEmails, peerEmail }) => {
//   return async (dispatch) => {
//     const sender = normEmail(senderEmail);
//     const parts = participantsEmails?.map(normEmail) || (peerEmail ? [sender, normEmail(peerEmail)] : []);
//     if (!sender || parts.length < 2) throw new Error("participantsEmails or peerEmail required");

//     let id = threadId;

//     if (!id && parts.length === 2) {
//       const tk = threadKeyFromTwo(parts[0], parts[1]);
//       id = await ensureDMThread({ aEmail: parts[0], bEmail: parts[1] })();
//       if (!id) id = tk;
//     }
//     if (!id) throw new Error("threadId is required for group messages.");

//     dispatch({ type: MSG_SENDING });

//     // Uploads
//     // const uploads = [];
//     // if (files && files.length > 0) {
//     //   for (const f of Array.from(files)) {
//     //     const path = `chat/${id}/${Date.now()}_${f.name}`;
//     //     const r = sref(storage, path);
//     //     const task = uploadBytesResumable(r, f);
//     //     uploads.push(new Promise((resolve, reject) => {
//     //       task.on("state_changed",
//     //         (snap) => {
//     //           const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
//     //           dispatch({ type: MSG_UPLOAD_PROGRESS, payload: { fileName: f.name, pct } });
//     //         },
//     //         reject,
//     //         async () => {
//     //           const url = await getDownloadURL(task.snapshot.ref);
//     //           resolve({ url, name: f.name, size: f.size, type: f.type?.startsWith("image") ? "image" : "file" });
//     //         }
//     //       );
//     //     }));
//     //   }
//     // }
//     const uploads = [];
//     if (files && files.length > 0) {
//       for (const f of Array.from(files)) {
//         const path = `chat/${id}/${Date.now()}_${f.name}`;
//         const r = sref(storage, path);
//         const task = uploadBytesResumable(r, f);

//         uploads.push(new Promise((resolve, reject) => {
//           task.on("state_changed",
//             (snap) => {
//               const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
//               dispatch({
//                 type: MSG_UPLOAD_PROGRESS,
//                 payload: { fileName: f.name, pct }
//               });
//             },
//             reject,
//             async () => {
//               const url = await getDownloadURL(task.snapshot.ref);
//               resolve({
//                 url,
//                 name: f.name,
//                 size: f.size,
//                 type: f.type?.startsWith("image") ? "image" : "file"
//               });
//             }
//           );
//         }));
//       }
//     }


//     try {
//       const attachments = await Promise.all(uploads);
//       const links = detectLinks(text || "");
//       await addDoc(collection(db,"messages"), {
//         threadId: id,
//         participantsEmails: parts.sort(),
//         senderEmail: sender,
//         senderName: senderName || sender,
//         text: text || "",
//         links,
//         attachments,
//         createdAt: serverTimestamp(),
//       });

//       await touchThreadOnSend({
//         threadId: id,
//         lastMessage: text || (attachments[0]?.name || "Attachment"),
//         lastFrom: sender
//       })();

//       dispatch({ type: MSG_SENT });
//     } catch (err) {
//       dispatch({ type: MSG_SEND_ERROR, payload: err.message });
//     }
//   };
// };

export const sendMessage = ({ threadId, senderEmail, senderName, text, files, participantsEmails, peerEmail }) => {
  return async (dispatch) => {
    const sender = normEmail(senderEmail);
    const parts = participantsEmails?.map(normEmail) || (peerEmail ? [sender, normEmail(peerEmail)] : []);
    if (!sender || parts.length < 2) throw new Error("participantsEmails or peerEmail required");

    let id = threadId;
    if (!id && parts.length === 2) {
      const tk = threadKeyFromTwo(parts[0], parts[1]);
      id = await ensureDMThread({ aEmail: parts[0], bEmail: parts[1] })();
      if (!id) id = tk;
    }
    if (!id) throw new Error("threadId is required for group messages.");


    const tempId = "temp-" + Date.now();
    const pendingMsg = {
      id: tempId,
      threadId: id,
      participantsEmails: parts.sort(),
      senderEmail: sender,
      senderName: senderName || sender,
      text: text || "",
      links: detectLinks(text || ""),
      attachments: (files || []).map(f => ({
        name: f.name,
        size: f.size,
        type: f.type?.startsWith("image") ? "image" : "file",
        progress: 0,
        uploading: true
      })),
      createdAt: new Date(),
      _pending: true,
    };

    dispatch({ type: MSG_SENDING, payload: pendingMsg });


    const uploads = [];
    if (files && files.length > 0) {
      for (const f of Array.from(files)) {
        const path = `chat/${id}/${Date.now()}_${f.name}`;
        const r = sref(storage, path);
        const task = uploadBytesResumable(r, f);

        uploads.push(new Promise((resolve, reject) => {
          task.on("state_changed",
            (snap) => {
              const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
              dispatch({
                type: MSG_UPLOAD_PROGRESS,
                payload: { tempId, fileName: f.name, pct }
              });
            },
            reject,
            async () => {
              const url = await getDownloadURL(task.snapshot.ref);
              resolve({ url, name: f.name, size: f.size, type: f.type?.startsWith("image") ? "image" : "file" });
            }
          );
        }));
      }
    }

    try {
      const attachments = await Promise.all(uploads);
      const links = detectLinks(text || "");

      
      const docRef = await addDoc(collection(db, "messages"), {
        threadId: id,
        participantsEmails: parts.sort(),
        senderEmail: sender,
        senderName: senderName || sender,
        text: text || "",
        links,
        attachments,
        createdAt: serverTimestamp(),
      });

      await touchThreadOnSend({
        threadId: id,
        lastMessage: text || (attachments[0]?.name || "Attachment"),
        lastFrom: sender
      })();


      dispatch({
        type: MSG_SENT,
        payload: { tempId, realMessage: { id: docRef.id, text, attachments, senderEmail: sender, senderName } }
      });

    } catch (err) {
      dispatch({
        type: MSG_SEND_ERROR,
        payload: { tempId, error: err.message }
      });
    }
  };
};




let _unsubGlobal = null;
export const listenToIncomingGlobal = ({ meEmail, onIncoming }) => (dispatch) => {
  const me = normEmail(meEmail);
  if (!me) return () => {};
  try { _unsubGlobal?.(); } catch {}

  const q = query(
    collection(db,"messages"),
    where("participantsEmails","array-contains", me),
    orderBy("createdAt","desc"),
    limit(20)
  );
  _unsubGlobal = onSnapshot(q, (snap) => {
    snap.docChanges().forEach(change => {
      if (change.type === "added") {
        const m = { id: change.doc.id, ...change.doc.data() };
        if (m.senderEmail !== me) onIncoming?.(m);
      }
    });
  });
  return () => { try{_unsubGlobal?.();}catch{} _unsubGlobal = null; };
};

export const togglePinMessage = ({ messageId, pinned }) => async (dispatch , getState) => {
  if (messageId.startsWith("temp-")) return;
  const { loginAuth: { userDetails } } = getState();
  const actor = userDetails?.email;

  dispatch({
    type: MSG_TOGGLE_PIN,
    payload: { messageId, pinned: !!pinned }
  });

  await updateDoc(doc(db, "messages", messageId), { pinned: !!pinned });


  await addSystemMessage({
    threadId: (getState().messages.threadId),
    event: pinned ? "pinned" : "unpinned",
    actor,
    extra: { targetMessageId: messageId }
  });

};

export const toggleReaction = ({ messageId, emoji, meEmail, add }) => async () => {
  if (messageId.startsWith("temp-")) return;
  const path = `reactions.${emoji}`;
  const ref = doc(db,"messages", messageId);
  await updateDoc(ref, { [path]: add ? arrayUnion(meEmail.toLowerCase()) : arrayRemove(meEmail.toLowerCase()) });
};

export const markMessagesRead = ({ threadId, meEmail, messageIds }) => async () => {
  const me = (meEmail || "").toLowerCase();
  if (!me || !threadId || !Array.isArray(messageIds) || !messageIds.length) return;
  const batch = (await import("firebase/firestore")).writeBatch(db);
  for (const id of messageIds) {
    if (id.startsWith("temp-")) continue;
    batch.update(doc(db,"messages", id), { readBy: arrayUnion(me) });
  }
  await batch.commit();
};


export const listenToPinnedMessages = (threadId) => (dispatch) => {
  if (!threadId) return () => {};
  const q = query(
    collection(db,"messages"),
    where("threadId","==", threadId),
    where("pinned","==", true),
    orderBy("createdAt","asc")
  );
  return onSnapshot(q, (snap) => {
    console.log("Pinned snap size:", snap.size);
    const pinned = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    console.log("Pinned docs:", pinned);
    dispatch({ type: MSG_SET_PINNED_LIST, payload: pinned });
  });
};


export const addSystemMessage = async ({ threadId, event, actor, extra }) => {
  await addDoc(collection(db, "messages"), {
    threadId,
    type: "system",
    event,         
    actor,         
    ...extra,     
    createdAt: serverTimestamp(),
  });
};


export const listenToUnreadCount = ({ meEmail, onUpdate }) => {
  if (!meEmail) return () => {};

  const q = query(
    collection(db, "messages"),
    where("participantsEmails", "array-contains", meEmail)
  );

  const unsub = onSnapshot(q, (snap) => {
    let unread = 0;

    snap.forEach((doc) => {
      const m = doc.data();

      if (m.senderEmail === meEmail) return;

      if (!Array.isArray(m.readBy) || !m.readBy.includes(meEmail)) {
        unread++;
      }
    });

    onUpdate(unread);
  });

  return unsub;
};